import React from "react";
import {observer} from "mobx-react";
import {useServices} from '../../../../react-hooks/use-services.hook';
import {Nullable} from "../../../../../common/types/nullable-types";
import {GameInfo} from "../../../../services/games/game-info";
import {VideoSlidesFilterItemPreviewFooterBox} from "./footer/video-slides-filter-item-preview-footer.box";
import {VideoSlidesFilterItemPreviewFooterTextBox} from "./footer-text/video-slides-filter-item-preview-footer-text.box";
import {VideoSlidesFilterItemPreviewBox} from "./container/video-slides-filter-item-preview.box";
import {IGameFilterDefinition} from "../../../../services/games-filter/filters-definitions/game-filter-definition.interface";
import {VideoSlidesFilterItemPreviewPlayerBox} from "./player/video-slides-filter-item-preview-player.box";

interface VideoSlidesFilterItemPreviewProps {
    filterId: string;
    filterCount: number;
}
export const VideoSlidesFilterItemPreviewComponent: React.FC<VideoSlidesFilterItemPreviewProps> = observer((props) => {
    const services = useServices();
    const filtersMap: Record<string, IGameFilterDefinition> = services.gamesFilter.getFiltersDefinitions([props.filterId]);

    const gameType: Nullable<GameInfo> = services.videoSlides.firstGameForFilter(props.filterId);

    if (!gameType) {
        return null;
    }

    return (
        <VideoSlidesFilterItemPreviewBox
            filterCount={props.filterCount}
            onClick={() => { services.videoSlides.navigateToFilter(props.filterId);}} >
            {/* For the video element I cannot conditionally render it for this.props.isInCenterStage because when the video reaches end and the user
        swipes right/left it renders again and starts again */}
            <VideoSlidesFilterItemPreviewPlayerBox
                gameInfo={gameType}
                muted={true}
                onError={() => {}} //TODO we will have a task for videoPlayer
                onLoading={() => {}}
                onWatchTimeLimitReached={() => {}}
                isInCenterStage={true}
                inViewport={true}
                display={true}
                videoPlayingService={services.videoOnDemandPlaying}
                loop={true}
            />
            <VideoSlidesFilterItemPreviewFooterBox>
                <VideoSlidesFilterItemPreviewFooterTextBox>
                    {filtersMap[props.filterId]?.text ?? props.filterId}
                </VideoSlidesFilterItemPreviewFooterTextBox>
            </VideoSlidesFilterItemPreviewFooterBox>
        </VideoSlidesFilterItemPreviewBox>
    )

})